import { getAllProducts } from '../services/api';

/// Preserva o espaço inicial (modo "contém" do ZenPDV) e remove só espaços à direita.
export function normalizeSearchTerm(text) {
  if (text == null) return '';
  return String(text).replace(/[\r\n\t]+/g, '').replace(/\s+$/g, '');
}

/// Hint padrão das buscas de produto (código / EAN / referência / descrição).
export const PRODUCT_SEARCH_HINT =
  'Código, EAN, referência, código extra ou descrição — Enter/bip adiciona (espaço no início = contém)';

export const PRODUCT_BARCODE_HINT =
  'Bipe o código de barras ou digite e pressione Enter';

export function termoEhBuscaParcial(termo) {
  const bruto = String(termo ?? '');
  return bruto.startsWith(' ') || bruto.startsWith('\t');
}

export function termoBuscaApi(termo) {
  return normalizeSearchTerm(termo);
}

export function fatorCodigoAdicional(produto, codigoBusca) {
  const termo = String(codigoBusca || '').trim().toLowerCase();
  if (!termo || !produto) return 1;
  const codigo = String(produto.codigo || '').toLowerCase();
  const ean = String(produto.ean || '').toLowerCase();
  const referencia = String(produto.referencia || '').toLowerCase();
  if (codigo === termo || ean === termo || referencia === termo) return 1;
  const extra = (produto.codigosAdicionais || []).find(
    (c) => String(c.codigo || '').trim().toLowerCase() === termo,
  );
  const qtd = Number(extra?.quantidade);
  return Number.isFinite(qtd) && qtd > 0 ? qtd : 1;
}

/// Correspondência exata: código principal, EAN, referência ou código adicional (caixa/variação).
export function produtoCombinaCodigoExato(produto, codigoBusca) {
  const termo = String(codigoBusca || '').trim().toLowerCase();
  if (!termo || !produto) return false;
  if (String(produto.codigo || '').trim().toLowerCase() === termo) return true;
  if (String(produto.ean || '').trim().toLowerCase() === termo) return true;
  if (String(produto.referencia || '').trim().toLowerCase() === termo) return true;
  return (produto.codigosAdicionais || []).some(
    (c) => String(c.codigo || '').trim().toLowerCase() === termo,
  );
}

export function resolverProdutosPorCodigo(produtos, codigoBusca) {
  const termo = String(codigoBusca || '').trim();
  if (!termo) return { modo: 'vazio', produtos: [] };

  const exatos = (produtos || []).filter((p) => produtoCombinaCodigoExato(p, termo));
  if (exatos.length === 1) {
    return {
      modo: 'unico',
      produto: exatos[0],
      quantidade: fatorCodigoAdicional(exatos[0], termo),
      produtos: exatos,
    };
  }
  if (exatos.length > 1) {
    return { modo: 'multiplos', produtos: exatos };
  }
  return { modo: 'lista', produtos: produtos || [] };
}

export async function buscarProdutosLista({
  termo,
  indice = 1,
  qtde = 30,
  estabelecimentoId,
  ativo,
} = {}) {
  const termoApi = termoBuscaApi(termo);
  const { data } = await getAllProducts({
    indice,
    qtde,
    termo: termoApi,
    estabelecimentoId: estabelecimentoId || '',
    ...(ativo != null && ativo !== '' ? { ativo } : {}),
  });
  return data?.items || [];
}

/**
 * Enter / leitor de barras: tenta lançar por código exato; senão devolve lista para escolha.
 * @returns {Promise<{ tipo: 'vazio'|'adicionar'|'lista'|'nao_encontrado', produto?, quantidade?, produtos?, mensagem? }>}
 */
export async function processarBuscaProdutoEnter({
  termo,
  estabelecimentoId,
  ativo,
  qtde = 30,
  preferirCodigoExato = true,
}) {
  const termoApi = termoBuscaApi(termo);
  if (!termoApi) return { tipo: 'vazio' };

  const parcial = termoEhBuscaParcial(termo);
  const produtos = await buscarProdutosLista({
    termo,
    qtde,
    estabelecimentoId,
    ativo,
  });

  if (!parcial && preferirCodigoExato) {
    const resolvido = resolverProdutosPorCodigo(produtos, termoApi);
    if (resolvido.modo === 'unico') {
      return {
        tipo: 'adicionar',
        produto: resolvido.produto,
        quantidade: resolvido.quantidade,
      };
    }
    if (resolvido.modo === 'multiplos') {
      return { tipo: 'lista', produtos: resolvido.produtos };
    }
    if (produtos.length === 0) {
      return {
        tipo: 'nao_encontrado',
        mensagem: `Nenhum produto encontrado para "${termoApi}".`,
      };
    }
  }

  if (produtos.length === 0) {
    return {
      tipo: 'nao_encontrado',
      mensagem: parcial
        ? 'Nenhum produto encontrado para esta busca.'
        : `Nenhum produto encontrado para "${termoApi}".`,
    };
  }

  return { tipo: 'lista', produtos };
}
